import BaseAPI from "../api";

const path: string = "/visa-satisfaction";

export class VisaSatisfactionApi extends BaseAPI {
  static list(query?: any): Promise<any> {
    return this.api.get(`${path}/question`, {
      params: { ...query },
    });
  }
  static post(body?: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }
  static visarequest(id?: any): Promise<any> {
    return this.api.get(`${path}/visarequest/${id}`);
  }
}
